import { Box, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { c } from "../../../theme/colorUtils";

export const DeviceCard = styled(Stack)(() => ({
  flexDirection: "row",
  alignItems: "center",
  gap: 16,
  padding: "16px",
  background: c.bg,
  border: `1px solid ${c.grayLight}`,
  borderRadius: 16,
}));

export const DeviceIconWrap = styled(Box)(() => ({
  width: 48,
  height: 48,
  padding: 8,
  borderRadius: "50%",
  background: "#F0F1F5",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  flexShrink: 0,
  overflow: "hidden",
  "& img": {
    width: "65%",
  },
}));

export const DeviceInfo = styled(Stack)(() => ({
  flex: 1,
  minWidth: 0,
  gap: 4,
}));
